// src/components/FavButton.jsx
import React from 'react';
import styled from 'styled-components';

const Btn = styled.button`
  --size: ${p => p.$size || 64}px; /* большое по умолчанию */
  width: var(--size);
  height: var(--size);
  border-radius: 12px;
  border: 1px solid var(--bdr);
  background: var(--card);
  color: var(--muted);
  box-shadow: var(--shadow);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background .18s ease, border-color .18s ease, color .18s ease, transform .08s ease;
  cursor: pointer;

  svg { width: calc(var(--size) * 0.48); height: calc(var(--size) * 0.48); display:block; }

  &[data-on="true"]{
    background: var(--primary);
    color: var(--primaryFg);
    border-color: transparent;
  }

  &:hover{ transform: translateY(-1px); }
  &:active{ transform: scale(0.98); }
`;

function HeartIcon() {
  // такой же path, как в Header
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d="M12.1 21.35c-.1 0-.2 0-.3-.1C6.14 17.24 3 13.98 3 10.25 3 7.35 5.35 5 8.25 5c1.71 0 3.32.8 4.35 2.07A5.56 5.56 0 0 1 16.95 5C19.85 5 22.2 7.35 22.2 10.25c0 3.73-3.14 6.99-8.8 11.01-.1.07-.2.09-.3.09z"/>
    </svg>
  );
}

export default function FavButton({
  on = false,
  onToggle,
  size = 64,
  titleOn = 'В избранном',
  titleOff = 'Добавить в избранное',
  className
}) {
  return (
    <Btn
      type="button"
      className={className}
      $size={size}
      data-on={on ? 'true' : 'false'}
      aria-pressed={on ? 'true' : 'false'}
      title={on ? titleOn : titleOff}
      onClick={(e) => { e.stopPropagation(); onToggle && onToggle(); }}
      onMouseDown={(e) => e.preventDefault()}
    >
      <HeartIcon />
    </Btn>
  );
}
